module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Finalize Your Order")]), _c('section', {
    staticClass: "checkout"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('form', {
    staticClass: "order-form"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v(" Billing")]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing.firstName),
      expression: "billing.firstName"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "First Name...",
      "name": "firstName"
    },
    domProps: {
      "value": (_vm.billing.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing.firstName = $event.target.value
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing.secondName),
      expression: "billing.secondName"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Second Name...",
      "name": "secondName"
    },
    domProps: {
      "value": (_vm.billing.secondName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing.secondName = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "email",
      "placeholder": "Email...",
      "name": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.phone),
      expression: "phone",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Phone...",
      "name": "phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing.country),
      expression: "billing.country"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Country...",
      "name": "country"
    },
    domProps: {
      "value": (_vm.billing.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing.country = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing.address),
      expression: "billing.address"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Billing Address",
      "name": "address"
    },
    domProps: {
      "value": (_vm.billing.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing.address = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing.city),
      expression: "billing.city"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "City...",
      "name": "city"
    },
    domProps: {
      "value": (_vm.billing.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing.city = $event.target.value
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.billing.zip),
      expression: "billing.zip",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Zip...",
      "name": "zip"
    },
    domProps: {
      "value": (_vm.billing.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing.zip = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('div', {
    staticClass: "input-checkbox"
  }, [_c('input', {
    staticClass: "input-check",
    attrs: {
      "type": "checkbox",
      "id": "address"
    },
    on: {
      "click": _vm.remAddress
    }
  }), _c('label', {
    staticClass: "input-label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Remember address?")])]), _c('div', {
    staticClass: "input-checkbox"
  }, [_c('input', {
    staticClass: "input-check",
    attrs: {
      "type": "checkbox",
      "id": "shipping"
    },
    on: {
      "click": _vm.completeShipping
    }
  }), _c('label', {
    staticClass: "input-label",
    attrs: {
      "for": "shipping"
    }
  }, [_vm._v("Same shipping address?")])])])]), _c('form', {
    staticClass: "order-form"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v(" Shipping")]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.firstName),
      expression: "shipping.firstName"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "First Name...",
      "name": "firstName"
    },
    domProps: {
      "value": (_vm.shipping.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.firstName = $event.target.value
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.secondName),
      expression: "shipping.secondName"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Second Name...",
      "name": "secondName"
    },
    domProps: {
      "value": (_vm.shipping.secondName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.secondName = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.country),
      expression: "shipping.country"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Country...",
      "name": "country"
    },
    domProps: {
      "value": (_vm.shipping.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.country = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.address),
      expression: "shipping.address"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Shipping Address",
      "name": "address"
    },
    domProps: {
      "value": (_vm.shipping.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.address = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.city),
      expression: "shipping.city"
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "City...",
      "name": "city"
    },
    domProps: {
      "value": (_vm.shipping.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.city = $event.target.value
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.shipping.zip),
      expression: "shipping.zip",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Zip...",
      "name": "zip"
    },
    domProps: {
      "value": (_vm.shipping.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.zip = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment"
  }, [_c('div', {
    staticClass: "widget-payment"
  }, [_c('h2', {
    staticClass: "widget-title"
  }, [_vm._v("Payment Options")]), _c('div', {
    staticClass: "payment-option"
  }, [_c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/paypal.svg")
    }
  })]), _c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/visa.svg")
    }
  })]), _c('a', {
    staticClass: "option-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/mastercard.svg")
    }
  })])]), _c('form', {
    staticClass: "payment-data"
  }, [_c('input', {
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Owner Name..."
    }
  }), _c('input', {
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Account Number..."
    }
  }), _c('input', {
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Date..."
    }
  }), _c('input', {
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "CVV Code..."
    }
  })])]), _c('div', {
    staticClass: "payment-total"
  }, [_c('h2', [_vm._v("Cart Total")]), _c('div', {
    staticClass: "subtotal-line"
  }, [_c('p', [_vm._v("Subtotal")]), _c('p', [_vm._v("$15")])]), _c('div', {
    staticClass: "total-line"
  }, [_c('p', [_vm._v("Total")]), _c('p', [_vm._v("$15")])]), _c('a', {
    staticClass: "action-btn"
  }, [_vm._v("Place Your Order")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-394b9e6c"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Checkout.vue
// module id = 125
// module chunks = 0